/* Plantica — questions: the answer grows instead of appearing

   `<details>` opens in one frame. The height is animated here, while the
   element stays a `<details>` — it keeps working without JS, and a screen
   reader is told the same thing either way. Opening sets `open` first and grows
   from nothing; closing shrinks and only then shuts, or the answer would vanish
   in the first frame of the closing.

   Bound once on the document rather than on each row, so questions that arrive
   later — a section reloaded by the customizer — need nothing.

   At `prefers-reduced-motion` nothing is intercepted: the browser's instant
   open is what that reader asked for.

   Custom file. See CUSTOMIZATIONS.md. */

(() => {
  const OPEN_MS = 240;
  const CLOSE_MS = 200;
  /* Deschiderea pornește repede și se așază. Închiderea nu poate folosi aceeași
     curbă: coada ei lungă târăște ultimii pixeli, iar rândul pare că se
     blochează înainte să se închidă. Nici invers (accelerare) nu e bine — atunci
     sare de la o treime direct la închis. O curbă simetrică ajunge lângă zero
     înainte de final, deci nu rămâne nimic de tăiat. */
  const EASE_OPEN = 'cubic-bezier(0.33, 1, 0.68, 1)';
  const EASE_CLOSE = 'cubic-bezier(0.45, 0, 0.55, 1)';
  const playing = new WeakMap();

  const smooth = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const slide = (item, panel, opening) => {
    const running = playing.get(item);
    if (running) running.cancel();

    // Measured while open, so it is the height the answer will really take.
    const full = panel.scrollHeight;
    panel.style.overflow = 'hidden';

    const move = panel.animate(
      [
        { height: `${opening ? 0 : full}px`, opacity: opening ? 0 : 1 },
        { height: `${opening ? full : 0}px`, opacity: opening ? 1 : 0 },
      ],
      {
        duration: opening ? OPEN_MS : CLOSE_MS,
        easing: opening ? EASE_OPEN : EASE_CLOSE,
        // La închidere, ultimul cadru se ține până când `open` chiar se ia:
        // fără el, panoul revine o clipă la înălțimea lui întreagă și abia
        // apoi dispare — se vede ca o smucitură la capăt.
        fill: opening ? 'none' : 'forwards',
      }
    );
    playing.set(item, move);

    move.onfinish = () => {
      playing.delete(item);
      panel.style.removeProperty('overflow');
      if (!opening) {
        item.open = false;
        move.cancel();
      }
    };
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.plantica-faq__summary');
    if (!summary) return;

    const item = summary.closest('.plantica-faq__item');
    const panel = item && item.querySelector('.plantica-faq__answer');
    if (!panel || !smooth()) return;

    event.preventDefault();

    if (item.open) {
      slide(item, panel, false);
    } else {
      item.open = true;
      slide(item, panel, true);
    }
  });
})();
